export default {
  START: "FETCH_USERS_START",
  SUCCESS: "FETCH_USERS_SUCCESS",
  FAIL: "FETCH_USERS_FAIL",
};
